function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m77 206.271 138.541-69.271-138.541-69.271zm30-90 41.459 20.729-41.459 20.729z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m347 182c-26.989 0-52.486 6.514-75 18.052v-200.052h-272v272h200.052c-11.538 22.514-18.052 48.011-18.052 75 0 90.981 74.019 165 165 165s165-74.019 165-165-74.019-165-165-165zm134.162 180c-2.888 26-13.186 49.792-28.733 69.216l-20.576-20.576-21.213 21.213 20.576 20.576c-19.424 15.547-43.216 25.846-69.216 28.733v-29.162h-30v29.162c-26-2.887-49.792-13.186-69.216-28.733l20.576-20.576-21.213-21.213-20.576 20.576c-15.547-19.424-25.846-43.216-28.733-69.216h29.162v-30h-29.162c2.888-26 13.186-49.792 28.733-69.216l20.576 20.576 21.213-21.213-20.576-20.576c19.424-15.547 43.216-25.846 69.216-28.733v29.162h30v-29.162c26 2.887 49.792 13.186 69.216 28.733l-20.576 20.576 21.213 21.213 20.576-20.576c15.547 19.424 25.846 43.216 28.733 69.216h-29.162v30zm-451.162-120v-212h212v189.814c-8.076 6.679-15.507 14.11-22.186 22.186z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m362 272h-30v90h60v-30h-30z"
}));

function SvgMarketing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.b36f556a.svg";
export { ForwardRef as ReactComponent };